import React, { useEffect } from "react";
import { Modal, Button, Alert, FormRow } from 'components/common';
import { useDispatch } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { adjustToNoon } from 'helpers/utils';
import { endOfMonth, format } from "date-fns";
import PropTypes from 'prop-types';
import { generatePeriodOrder } from 'redux/crm/shipment/orderIntakeSlice';
import { INPUT_CLS } from "helpers/formStyles";

const FORM_ID = 'general-period-form';

const GeneralPeriodForm = ({ open, setOpen }) => {
  const { control, handleSubmit, formState: { errors }, setValue } = useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    setValue("period", adjustToNoon(new Date()));
  }, [setValue]);

  const closeModal = () => setOpen(false);

  const onSubmit = async (data) => {
    const yearMonth = format(data.period, 'yyyy-MM');
    try {
      await dispatch(generatePeriodOrder({
        start_date: `${yearMonth}-01`,
        end_date: format(endOfMonth(data.period), 'yyyy-MM-dd'),
      }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const footer = (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-w-full">
      <Button type="submit" form={FORM_ID} variant="primary" size="sm">Submit</Button>
      <Button type="button" onClick={closeModal} variant="ghost" size="sm">Cancel</Button>
    </div>
  );

  return (
    <Modal show={open} onHide={closeModal} title="Generate period" size="md" footer={footer}>
      <form id={FORM_ID} onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">Are you sure you want to generate this period?</Alert>

        <FormRow label="Period" required error={errors.period?.message}>
          <Controller
            control={control}
            name="period"
            rules={{ required: "Period is required." }}
            render={({ field }) => (
              <DatePicker
                selected={field.value}
                onChange={d => field.onChange(adjustToNoon(d))}
                className={INPUT_CLS}
                placeholderText="MM-yyyy"
                dateFormat="MM-yyyy"
                showMonthYearPicker
                fixedHeight
              />
            )}
          />
        </FormRow>
      </form>
    </Modal>
  );
};

GeneralPeriodForm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default GeneralPeriodForm;
